import { Button } from '@neo/primitives/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@neo/primitives/dropdown-menu'
import { Ellipsis, X } from 'lucide-react'
import { useFeatureFlags } from 'v2/shared/hooks/use-feature-flags'
import { useFlowStore } from '../../../store'
import { useVibeAgentStore } from '../store'
import { VibeCopySessionId } from './copy-session-id'
import { VibeDebugDownloadButton } from './debug-download-button'
import { VibeNewChatButton } from './new-chat-button'

export const VibeChatHeader = () => {
  const { isDebuggingMode } = useFeatureFlags()
  const setShowVibeSidebar = useFlowStore((state) => state.setShowVibeSidebar)
  const sessionId = useVibeAgentStore((state) => state.sessionId)
  const hasTranscript = useVibeAgentStore((state) => state.transcript.length > 0)

  const hasConversation = !!sessionId || hasTranscript

  return (
    <div className="flex justify-end items-center gap-0.5 py-2">
      <VibeNewChatButton />
      {hasConversation && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              data-testid="button-vibe-agent-menu"
              className="text-secondary hover:text-foreground hover:bg-bg2 h-8 w-8 transition-colors duration-150"
            >
              <Ellipsis className="w-4 h-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start" className="min-w-[160px]">
            <VibeCopySessionId />
            {hasTranscript && isDebuggingMode && <VibeDebugDownloadButton />}
          </DropdownMenuContent>
        </DropdownMenu>
      )}

      <Button
        variant="ghost"
        size="icon"
        onClick={() => setShowVibeSidebar(false)}
        tooltipContent="Close"
        data-testid="button-close-vibe-agent"
        className="text-secondary hover:text-foreground hover:bg-bg2 h-8 w-8 transition-colors duration-150"
      >
        <X className="w-4 h-4" />
      </Button>
    </div>
  )
}
